module.exports = __webpack_public_path__ + "img/no-okonomikurs.e7ecb03b.png";